import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable, of } from 'rxjs';
import languageListJson from '../../app/components/language-selection-page/language-list.json';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  public translatedArray: any = [];
  public languageType: string = '';
  private readonly translationContent = signal<any>(this.translatedArray);
  public sharetranslationData = toObservable(this.translationContent);
  private readonly languageContent = signal<any>(this.languageType);
  public sharelanguageType = toObservable(this.languageContent);
  private _featureFlags: any = null;
  private readonly _featureFlagLink = environment.featureFlagLink
  private _supportedLanguagesForDisplay: any[] = [];
  public supportedLanguages: any[] = [];
  public _cpConfig: any;

  private configLoadedSignal = signal(false);
  public configLoaded = this.configLoadedSignal.asReadonly();

  constructor(private readonly httpClient: HttpClient) {
   }
  sendtranslationValue(value: any) {
    this.translationContent.set(value);
  }
  sendSelectedLanguage(value: any) {
    this.languageContent.set(value);
  }


  setLanguageType(type: any) {
    this.languageType = type;
  }
  getLanguageType() {
    return this.languageType;
  }

  fetchConfigDetails() {
    return this.httpClient.get<any>(`${environment.proxyEndpoint}/app/config`);
  }

  public set cpConfig(secrets: any) {
    this._cpConfig = secrets;
  }

  public get cpConfig() {
    return this._cpConfig;
  }

  public getCustomerPortalConfiguration(_languageId?: string) {
    if (!this._cpConfig) {
      this.fetchConfigDetails().subscribe(
        (secrets: any) => {
          this._cpConfig = secrets;
      })
    }
  }

  public set featureFlags(flags: any) {
    this._featureFlags = flags;
  }

  public get featureFlags() {
    return this._featureFlags;
  }

  public getAllFeatureFlags(): Observable<any> {
    const featureFlags = this.httpClient.get(this._featureFlagLink)
    return featureFlags
  }

     /**
   * @description To be replaced by actual API. Gives list of all supported languages
   * @returns list of languages
   * !IMPORTANT: While testing with actual API, ensure error scenarios are also handled
   */
     public getAllSupportedLanguages(): Observable<any> {
      const res = languageListJson;
      return of(res);
    }

    public set supportedLanguagesForDisplay(languages: any[]) {
      const defaultLangs = ['en', 'de'];
      const langCodes = this.getLanguageCodes(languages)
      langCodes.push(...defaultLangs);
      this.setSupportedLanguageByCode(langCodes);
      this._supportedLanguagesForDisplay = languages.filter((lan: any) => lan.show);
    }

    public getLanguageCodes(languages: any[]): string[] {
      const langCodes = languages
      .filter(lang => lang.show)
      .map(lang => lang.localeCode)
      return langCodes;
    }

    public get supportedLanguagesForDisplay(): any[] {
      return this._supportedLanguagesForDisplay;
    }

    public setSupportedLanguageByCode(languages: string[]) {
      this.supportedLanguages = languages;
    }

  /**
    * @description We are using this method to pass a valid language to translations API
    * If user has added any invalid language, pass the default language
    * @param locale
    * @returns
    */
   public isLangIdValid(locale:any): string {
    const languages = languageListJson;
    const langCodes = this.getLanguageCodes(languages);
      if(langCodes.includes(locale)){
       return locale
      }else{
       return 'en-GB'
      }
   }


}

